import { jsx as _jsx } from "react/jsx-runtime";
export const ActivityRunner = ({ basePreviewURL }) => {
    return (_jsx("iframe", { src: basePreviewURL, width: '100%', height: '100%', title: 'ecoa-activity-view', "data-testid": 'ecoa-iframe-view', id: 'ecoa-activity-view' }));
};
